import './kp-customization-session.js?v=ux-20261018-cart-reuse-order-12';
(() => {
  if (window.__kpCartPersonalizationPreview) return;

  const SOURCE_WIDTH = 3024;
  const SOURCE_HEIGHT = 4032;
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const DATA_SELECTOR = '[data-kp-cart-preview-data]';
  const ROW_SELECTOR = '.cart-items__table-row';
  const MEDIA_SELECTOR = '.cart-items__media-container';

  const BASES = Object.freeze({
    'Classic White': Object.freeze({
      single: 'https://kippush.ca/cdn/shop/files/White_Satin_Classic.png?width=3840',
    }),
    'Lined White': Object.freeze({
      single: 'https://kippush.ca/cdn/shop/files/White_Satin_Lining_Single.png?v=1790521822&width=3840',
      paired:
        'https://kippush.ca/cdn/shop/files/White_Satin_Lining_68b6adf1-c2b0-45c2-bf16-e6228b4ef222.png?v=1790900485&width=3840',
    }),
    'Lined Navy': Object.freeze({
      single: 'https://kippush.ca/cdn/shop/files/blank-lined-navy-satin-kippah.png?v=1790883546&width=3840',
      paired:
        'https://kippush.ca/cdn/shop/files/Blue_Satin_Lining_7682ecf7-59a9-4433-b20b-7b9901f37015.png?v=1790900309&width=3840',
    }),
    'Lined Black': Object.freeze({
      single: 'https://kippush.ca/cdn/shop/files/blank-lined-black-satin-kippah.png?v=1790883547&width=3840',
      paired:
        'https://kippush.ca/cdn/shop/files/Black_Satin_Lining_fb1e6a81-7aae-41f3-a53e-75abc942e9d5.png?v=1790900258&width=3840',
    }),
  });

  const PLACEMENTS = Object.freeze({
    'Classic White': Object.freeze({
      single: Object.freeze({ x: 1265, y: 2097, angle: 3.5, side: 806 }),
    }),
    'Lined White': Object.freeze({
      single: Object.freeze({ x: 1350.04, y: 2097.53, angle: 1.8083, side: 840 }),
      outside: Object.freeze({ x: 887.26, y: 2256.85, angle: 3.8983, side: 582 }),
      inside: Object.freeze({ x: 2171.52, y: 1738.37, angle: 24.2037, side: 582 }),
    }),
    'Lined Navy': Object.freeze({
      single: Object.freeze({ x: 1304.24, y: 2099.15, angle: 6.0043, side: 840 }),
      outside: Object.freeze({ x: 726.73, y: 2160.73, angle: 22.1891, side: 582 }),
      inside: Object.freeze({ x: 2075.38, y: 1749.62, angle: 32.7999, side: 582 }),
    }),
    'Lined Black': Object.freeze({
      single: Object.freeze({ x: 1369.09, y: 2114.39, angle: 2.4074, side: 840 }),
      outside: Object.freeze({ x: 813.63, y: 2211.85, angle: 7.5003, side: 582 }),
      inside: Object.freeze({ x: 2029.39, y: 1794.61, angle: 24.3004, side: 582 }),
    }),
  });

  const SHAWL_SOURCE_WIDTH = 1536;
  const SHAWL_SOURCE_HEIGHT = 2048;
  const SHAWL_PLACEMENT = Object.freeze({ x: 800, y: 1313, angle: 21.5, side: 355 });

  const CUSTOM_PRODUCTS = Object.freeze({
    'custom-white-satin-kippah': 'Classic White',
    'custom-lined-satin-kippah': 'Lined White',
    'custom-lined-navy-satin-kippah': 'Lined Navy',
    'custom-lined-black-satin-kippah': 'Lined Black',
  });

  // Fresh snapshot of assets/kp-sparkles-noam-preview.js from TEST on 2026-10-03.
  // Keep this hash and map current so future collection additions cannot fail silently.
  const READY_MAPPING_SNAPSHOT = 'sha256:9235bc6a9549f213ca070e04acb48bdf36c14d063fb7b4771a81f98c8ab600a9';
  const READY_FILE_ROOT = 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/';
  const readyPair = (stem) =>
    Object.freeze({
      Silver: `${READY_FILE_ROOT}${stem}-silver.png`,
      Gold: `${READY_FILE_ROOT}${stem}-gold.png`,
    });
  const readySingle = (stem) =>
    Object.freeze({ Multicolor: `${READY_FILE_ROOT}${stem}.png` });
  const READY_ARTWORK = Object.freeze({
    'bar-mitzvah-kippah-1': readyPair('kp-ready-bar-mitzvah-star-of-david'),
    'bar-mitzvah-kippah-2': readyPair('kp-ready-bar-mitzvah-lions-and-crown'),
    'bar-mitzvah-ariel': readyPair('kp-ready-bar-mitzvah-star-of-david-and-laurel'),
    'bar-mitzvah-noam': Object.freeze({
      Silver: `${READY_FILE_ROOT}kp-sparkles-noam-silver.png?v=1790936871`,
      Gold: `${READY_FILE_ROOT}kp-sparkles-noam-gold.png?v=1790936886`,
    }),
    'bar-mitzvah-benjamin': readyPair('kp-ready-bar-mitzvah-tefillin'),
    'bar-mitzvah-gabriel': readyPair('kp-ready-bar-mitzvah-hamsa-hand'),
    'bar-mitzvah-levi': readyPair('kp-ready-bar-mitzvah-hamsa-hand-classic'),
    'bar-mitzvah-nathan': readyPair('kp-ready-bar-mitzvah-soccer-ball-number-13'),
    'bar-mitzvah-samuel': readyPair('kp-ready-bar-mitzvah-basketball-player'),
    'bar-mitzvah-michael': readyPair('kp-ready-bar-mitzvah-hockey-player'),
    'hegia-lmitzvot-bar-mitzvah-inside': readyPair('kp-ready-bar-mitzvah-hegia-lmitzvot-inside'),
    'hegia-lmitzvot-bar-mitzvah-outside': readyPair('kp-ready-bar-mitzvah-hegia-lmitzvot-outside'),
    'wedding-yael-roni': readyPair('kp-ready-wedding-interlocking-rings'),
    'wedding-maya-erez': readyPair('kp-ready-wedding-eucalyptus-greenery'),
    'wedding-eden-david': readyPair('kp-ready-wedding-interlocking-rings-classic'),
    'wedding-yonit-michael': readyPair('kp-ready-wedding-white-rose'),
    'wedding-sivan-benjamin': readyPair('kp-ready-wedding-rings'),
    'wedding-adam-hawa': readyPair('kp-ready-wedding-floral-bouquet'),
    'wedding-abraham-sarah': readyPair('kp-ready-wedding-hamsa-hand'),
    'wedding-boaz-ruth': readyPair('kp-ready-wedding-floral-bouquet-classic'),
    'wedding-aviv-noam': readyPair('kp-ready-wedding-simple-rings'),
    'wedding-rivkah-shalom': readyPair('kp-ready-wedding-heart-and-rings'),
    'rings-and-flowers-wedding-inside': readyPair('kp-ready-wedding-rings-flowers-inside'),
    'rings-and-flowers-wedding-outside': readyPair('kp-ready-wedding-rings-flowers-outside'),
    'brit-milah-moshe': readyPair('kp-ready-brit-milah-baby-pin-charms'),
    'brit-milah-daniel': readyPair('kp-ready-brit-milah-minimalist-baby-line-art'),
    'brit-milah-chaim': readyPair('kp-ready-brit-milah-heart-footprints'),
    'brit-milah-benjamin': readySingle('kp-ready-brit-milah-teddy-bear-classic'),
    'brit-milah-azriel': readySingle('kp-ready-brit-milah-star-of-david-balloons'),
    'brit-milah-alon': readySingle('kp-ready-brit-milah-teddy-bear-balloons'),
    'brit-milah-noah': readyPair('kp-ready-brit-milah-stars-hearts'),
    'brit-milah-david': readySingle('kp-ready-brit-milah-bear-balloons'),
    'brit-milah-levi': readySingle('kp-ready-brit-milah-hamsa-hand'),
    'brit-milah-eliezer': readySingle('kp-ready-brit-milah-teddy-bear-blue-ribbon-balloons'),
    'hanukkah-menora-holiday-kippah-1': readyPair('kp-ready-holiday-hanukkah-menora'),
    'hanukkah-menora-holiday-kippah': readyPair('kp-ready-holiday-hanukkah-menorah-classic'),
    'hanukkah-menorah-coloured-holiday-kippah': readySingle('kp-ready-holiday-hanukkah-menorah-coloured'),
    'hanukkah-menorah-simple-holiday-kippah': Object.freeze({ Silver: `${READY_FILE_ROOT}kp-ready-holiday-hanukkah-menorah-simple-silver.png?v=1791045560`, Gold: `${READY_FILE_ROOT}kp-ready-holiday-hanukkah-menorah-simple-gold.png?v=1791045551`, Blue: `${READY_FILE_ROOT}kp-ready-holiday-hanukkah-menorah-simple-blue.png?v=1791045543` }),
    'hanukkah-sevivon-coloured-holiday-kippah': readySingle('kp-ready-holiday-hanukkah-sevivon-coloured'),
    'hanukkah-sevivon-gold-silver-holiday-kippah': readySingle('kp-ready-holiday-hanukkah-sevivon-gold-silver'),
    'hanukkah-sufganiyah-holiday-kippah': readyPair('kp-ready-holiday-hanukkah-sufganiyah'),
    'shavuot-holiday-kippah': readyPair('kp-ready-holiday-shavuot'),
    'shavuot-classic-holiday-kippah': readyPair('kp-ready-holiday-shavuot-classic'),
    'shavuot-coloured-holiday-kippah': readySingle('kp-ready-holiday-shavuot-coloured'),
    'shavuot-simple-holiday-kippah': Object.freeze({ Silver: `${READY_FILE_ROOT}kp-ready-holiday-shavuot-simple-silver.png?v=1791045677`, Gold: `${READY_FILE_ROOT}kp-ready-holiday-shavuot-simple-gold.png?v=1791045643`, Purple: `${READY_FILE_ROOT}kp-ready-holiday-shavuot-simple-purple.png?v=1791045660` }),
    'shavuot-torah-holiday-kippah': readySingle('kp-ready-holiday-shavuot-torah'),
    'sukkot-holiday-kippah': readyPair('kp-ready-holiday-sukkot'),
    'sukkot-chag-sameach-holiday-kippah': readySingle('kp-ready-holiday-sukkot-chag-sameach'),
    'sukkot-classic-holiday-kippah': readyPair('kp-ready-holiday-sukkot-classic'),
    'sukkot-coloured-holiday-kippah': readySingle('kp-ready-holiday-sukkot-coloured'),
    'sukkot-simple-holiday-kippah': Object.freeze({ Silver: `${READY_FILE_ROOT}kp-ready-holiday-sukkot-simple-silver.png?v=1791045779`, Gold: `${READY_FILE_ROOT}kp-ready-holiday-sukkot-simple-gold.png?v=1791045758`, Green: `${READY_FILE_ROOT}kp-ready-holiday-sukkot-simple-green.png?v=1791045770` }),
  });

  const FIXED_READY_PAIRS = Object.freeze({
    'hegia-lmitzvot_bar-mitzvah': Object.freeze({
      outside: readyPair('kp-ready-bar-mitzvah-hegia-lmitzvot-outside'),
      inside: readyPair('kp-ready-bar-mitzvah-hegia-lmitzvot-inside'),
    }),
    'rings-and-flowers-wedding': Object.freeze({
      outside: readyPair('kp-ready-wedding-rings-flowers-outside'),
      inside: readyPair('kp-ready-wedding-rings-flowers-inside'),
    }),
  });

  const READY_LIGHT_ARTWORK = Object.freeze({
    'hanukkah-menorah-coloured-holiday-kippah': readySingle('kp-ready-holiday-hanukkah-menorah-coloured-light'),
    'hanukkah-sevivon-coloured-holiday-kippah': readySingle('kp-ready-holiday-hanukkah-sevivon-coloured-light'),
    'shavuot-coloured-holiday-kippah': readySingle('kp-ready-holiday-shavuot-coloured-light'),
    'shavuot-torah-holiday-kippah': readySingle('kp-ready-holiday-shavuot-torah-light'),
    'sukkot-chag-sameach-holiday-kippah': readySingle('kp-ready-holiday-sukkot-chag-sameach-light'),
    'sukkot-coloured-holiday-kippah': readySingle('kp-ready-holiday-sukkot-coloured-light'),
  });

  const imageCache = new Map();
  let renderTimer;

  const normalizeProperties = (value) => {
    if (!value) return {};
    if (!Array.isArray(value)) return value;

    return Object.fromEntries(
      value
        .filter((entry) => Array.isArray(entry) && entry.length >= 2)
        .map(([key, propertyValue]) => [String(key), propertyValue])
    );
  };

  const normalizeOptions = (value) => {
    if (!Array.isArray(value)) return {};

    return Object.fromEntries(
      value
        .filter((option) => option && typeof option.name === 'string')
        .map((option) => [option.name, option.value])
    );
  };

  const readLineData = (dataElement) => {
    try {
      const parsed = JSON.parse(dataElement.textContent || '{}');
      const properties = normalizeProperties(parsed.properties);
      const options = normalizeOptions(parsed.options);

      return {
        handle: typeof parsed.handle === 'string' ? parsed.handle : '',
        shawlBase: typeof parsed.shawlBase === 'string' ? parsed.shawlBase : '',
        values: { ...options, ...properties },
        fingerprint: dataElement.textContent || '',
      };
    } catch (error) {
      console.warn('[Kippush cart preview] Invalid line data.', error);
      return null;
    }
  };

  const uploadUrl = (value) => {
    if (typeof value !== 'string' || value.length > 2048) return '';

    try {
      const url = new URL(value, window.location.origin);
      if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com' || url.username || url.password || url.port || url.search || url.hash) return '';
      if (!/^\/s\/files\/1\/0718\/3135\/5545\/uploads\/[a-zA-Z0-9_.-]+$/.test(url.pathname)) return '';
      if (!/\.(?:png|jpe?g)$/i.test(url.pathname)) return '';
      return url.href;
    } catch {
      return '';
    }
  };

  const themeAssetUrl = (value) => {
    if (typeof value !== 'string' || value.length > 2048) return '';

    try {
      const url = new URL(value, window.location.origin);
      if (url.protocol !== 'https:') return '';
      if (!['kippush.ca', 'cdn.shopify.com'].includes(url.hostname)) return '';
      if (!url.pathname.startsWith('/cdn/shop/')) return '';
      return url.href;
    } catch {
      return '';
    }
  };

  const blockedUpload = (values, keys) =>
    keys.some((key) => typeof values[key] === 'string' && values[key].trim() && !uploadUrl(values[key]));

  const loadImage = (url) => {
    if (!url) return Promise.reject(new Error('Missing image URL'));
    if (imageCache.has(url)) return imageCache.get(url);

    const pending = new Promise((resolve, reject) => {
      const image = new Image();
      image.decoding = 'async';
      image.onload = () => resolve(url);
      image.onerror = () => reject(new Error(`Unable to load preview image: ${url}`));
      image.src = url;
    });

    imageCache.set(url, pending);
    pending.catch(() => imageCache.delete(url));
    return pending;
  };

  const svgImage = (url, geometry, side) => {
    const image = document.createElementNS(SVG_NS, 'image');
    image.dataset.side = side;
    image.setAttribute('href', url);
    image.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    image.setAttribute('x', String(geometry.x - geometry.side / 2));
    image.setAttribute('y', String(geometry.y - geometry.side / 2));
    image.setAttribute('width', String(geometry.side));
    image.setAttribute('height', String(geometry.side));
    image.setAttribute('transform', `rotate(${geometry.angle} ${geometry.x} ${geometry.y})`);
    return image;
  };

  const resolveShawl = (handle, values, shawlBase) => {
    if (handle !== 'custom-white-shawl') return null;
    const base = themeAssetUrl(shawlBase);
    if (!base) return { unmapped: true };

    const readyHandle = values['_Ready design handle'] || '';
    const printColor = values['Print Color'] || '';
    const artworkByColor = READY_ARTWORK[readyHandle];
    const onlyArtwork = artworkByColor && Object.keys(artworkByColor).length === 1
      ? Object.values(artworkByColor)[0]
      : '';
    let artwork = artworkByColor ? artworkByColor[printColor] || onlyArtwork : '';
    let status = artwork ? 'shawl-ready-artwork' : '';

    const uploadValue = values['Outside file/logo'] || values['Logo file'] || '';
    const hasUpload = typeof uploadValue === 'string' && uploadValue.trim();
    if (hasUpload) {
      artwork = uploadUrl(uploadValue);
      if (!artwork) return { blocked: true };
      status = 'shawl-custom-artwork';
    }

    const hasText = Boolean(String(values['Outside text'] || '').trim());
    if (!artwork && readyHandle) return { unmapped: true };
    if (!artwork && !hasText) return null;
    if (!artwork && hasText) status = 'shawl-text-only';
    const hasDetails = Boolean(
      values['Custom design details'] || values['Name'] || values['Date'] || values['Special instructions']
    );
    return {
      base,
      overlays: artwork ? [{ url: artwork, geometry: SHAWL_PLACEMENT, side: 'Shawl artwork' }] : [],
      label: hasDetails
        ? 'Design mockup only · actual personalization details listed below'
        : hasText
          ? 'Design mockup only · actual text listed below'
          : 'Design mockup only',
      status,
      sourceWidth: SHAWL_SOURCE_WIDTH,
      sourceHeight: SHAWL_SOURCE_HEIGHT,
    };
  };

  const resolveCustom = (handle, values) => {
    const kippah = CUSTOM_PRODUCTS[handle];
    if (!kippah) return null;

    const placement = kippah === 'Classic White' ? 'Outside Print' : values['Print Placement'] || '';
    if (blockedUpload(values, ['Outside file/logo', 'Inside file/logo'])) return { blocked: true };
    const isSingle = kippah === 'Classic White' || placement === 'Outside Print';
    const overlays = [];

    if (isSingle) {
      const outside = uploadUrl(values['Outside file/logo']);
      if (outside) overlays.push({ url: outside, geometry: PLACEMENTS[kippah]?.single, side: 'Outside' });
    } else if (placement === 'Inside Print') {
      const inside = uploadUrl(values['Inside file/logo']);
      if (inside) overlays.push({ url: inside, geometry: PLACEMENTS[kippah]?.inside, side: 'Inside' });
    } else if (placement === 'Double-Sided Print') {
      const outside = uploadUrl(values['Outside file/logo']);
      const inside = uploadUrl(values['Inside file/logo']);
      if (outside) overlays.push({ url: outside, geometry: PLACEMENTS[kippah]?.outside, side: 'Outside' });
      if (inside) overlays.push({ url: inside, geometry: PLACEMENTS[kippah]?.inside, side: 'Inside' });
    }

    const hasUnrenderedText = Boolean(values['Outside text'] || values['Inside text']);
    return {
      base: BASES[kippah]?.[isSingle ? 'single' : 'paired'],
      overlays: overlays.filter((overlay) => overlay.geometry),
      label: hasUnrenderedText ? 'Design mockup only · actual text listed below' : 'Design mockup only',
      status: overlays.length ? 'custom-artwork' : hasUnrenderedText ? 'text-not-rendered' : 'base-only',
    };
  };

  const resolveReady = (handle, values) => {
    const artworkByColor = READY_ARTWORK[handle];
    const fixedPair = FIXED_READY_PAIRS[handle];
    const looksReady = Boolean(artworkByColor || fixedPair || values.Name || values.Date || values['Ready design placement']);
    if (!artworkByColor && !fixedPair) {
      if (looksReady) {
        console.warn(
          `[Kippush cart preview] Ready handle "${handle}" is not in mapping snapshot "${READY_MAPPING_SNAPSHOT}".`
        );
      }
      return looksReady ? { unmapped: true } : null;
    }

    const kippah = values.Kippah || '';
    const printColor = values['Print Color'] || '';
    const placement = values['Print Placement'] || '';
    if (fixedPair) {
      const outside = fixedPair.outside[printColor] || '';
      const inside = fixedPair.inside[printColor] || '';
      const fixedOutsideGeometry = PLACEMENTS[kippah]?.outside;
      const outsideGeometry = handle === 'rings-and-flowers-wedding' && fixedOutsideGeometry
        ? { ...fixedOutsideGeometry, side: Math.round(fixedOutsideGeometry.side * 0.85) }
        : fixedOutsideGeometry;
      const insideGeometry = PLACEMENTS[kippah]?.inside;
      const base = BASES[kippah]?.paired;
      if (!base || !outside || !inside || !outsideGeometry || !insideGeometry) return { unmapped: true };
      return {
        base,
        overlays: [
          { url: outside, geometry: outsideGeometry, side: 'Outside ready design' },
          { url: inside, geometry: insideGeometry, side: 'Inside ready design' },
        ],
        label: 'Double-sided design mockup only · actual name and date listed below',
        status: 'ready-fixed-pair',
      };
    }
    const readySide = values['Ready design placement'] === 'Inside' ? 'inside' : 'outside';
    const isSingle = kippah === 'Classic White' || placement === 'Outside Print';
    const designSide = isSingle ? 'single' : placement === 'Inside Print' ? 'inside' : readySide;
    const lightByColor = READY_LIGHT_ARTWORK[handle];
    const palette = /^(?:Lined Navy|Lined Black)$/.test(kippah) && lightByColor ? lightByColor : artworkByColor;
    const onlyArtwork = Object.keys(palette).length === 1 ? Object.values(palette)[0] : '';
    const artwork = palette[printColor] || onlyArtwork || artworkByColor[printColor] || '';
    const geometry = PLACEMENTS[kippah]?.[designSide];
    if (!BASES[kippah] || !artwork || !geometry) return { unmapped: true };

    const overlays = [{ url: artwork, geometry, side: 'Ready design' }];
    const customSide = designSide === 'inside' ? 'Outside' : 'Inside';
    if (blockedUpload(values, [`${customSide} file/logo`])) return { blocked: true };
    const customUrl = uploadUrl(values[`${customSide} file/logo`]);
    const customGeometry = PLACEMENTS[kippah]?.[customSide.toLowerCase()];
    if (!isSingle && customUrl && customGeometry) {
      overlays.push({ url: customUrl, geometry: customGeometry, side: customSide });
    }

    const hasUnrenderedText = Boolean(values['Outside text'] || values['Inside text']);
    return {
      base: BASES[kippah][isSingle ? 'single' : 'paired'],
      overlays,
      label: hasUnrenderedText
        ? 'Design mockup only · actual name, date, and text listed below'
        : 'Design mockup only · actual name and date listed below',
      status: 'ready-artwork',
    };
  };

  const buildPreview = (preview) => {
    const figure = document.createElement('figure');
    figure.className = 'kp-cart-preview';
    figure.dataset.kpCartPreviewStatus = preview.status;
    figure.setAttribute('aria-label', preview.label);

    const base = document.createElement('img');
    base.className = 'kp-cart-preview__base';
    base.src = preview.base;
    base.alt = '';
    base.decoding = 'async';

    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.classList.add('kp-cart-preview__overlay');
    svg.setAttribute(
      'viewBox',
      `0 0 ${preview.sourceWidth || SOURCE_WIDTH} ${preview.sourceHeight || SOURCE_HEIGHT}`
    );
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    svg.setAttribute('aria-hidden', 'true');
    preview.overlays.forEach((overlay) => svg.append(svgImage(overlay.url, overlay.geometry, overlay.side)));

    const label = document.createElement('figcaption');
    label.className = 'kp-cart-preview__label';
    label.textContent = preview.label;

    figure.append(base, svg, label);
    return figure;
  };

  const clearPreview = (row) => {
    row.querySelector('.kp-cart-preview')?.remove();
    row.querySelector(MEDIA_SELECTOR)?.classList.remove('kp-cart-preview-active');
  };

  const renderLine = async (dataElement) => {
    const row = dataElement.closest(ROW_SELECTOR);
    const media = row?.querySelector(MEDIA_SELECTOR);
    if (!row || !media) return;

    const data = readLineData(dataElement);
    if (!data) {
      row.dataset.kpCartPreviewStatus = 'invalid-data';
      clearPreview(row);
      return;
    }

    if (row.dataset.kpCartPreviewFingerprint === data.fingerprint && row.querySelector('.kp-cart-preview')) return;

    const preview =
      resolveShawl(data.handle, data.values, data.shawlBase) ||
      resolveCustom(data.handle, data.values) ||
      resolveReady(data.handle, data.values);
    if (!preview || preview.unmapped || preview.blocked || !preview.base) {
      row.dataset.kpCartPreviewStatus = preview?.blocked
        ? 'blocked-upload'
        : preview?.unmapped
          ? 'unmapped'
          : 'not-personalized';
      row.dataset.kpCartPreviewFingerprint = data.fingerprint;
      clearPreview(row);
      return;
    }

    // Mockup-only calibration; saved artwork coordinates and logo placement stay unchanged.
    if(data.handle!=='custom-white-shawl')preview.overlays=preview.overlays.map(overlay=>data.values[overlay.side+' design method']==='Your text design'?{...overlay,geometry:{...overlay.geometry,y:overlay.geometry.y-overlay.geometry.side*.05}}:overlay);
    const requiredUrls = [preview.base, ...preview.overlays.map((overlay) => overlay.url)];
    try {
      await Promise.all(requiredUrls.map(loadImage));
    } catch (error) {
      console.warn('[Kippush cart preview] Falling back to the normal product image.', error);
      row.dataset.kpCartPreviewStatus = 'image-error';
      row.dataset.kpCartPreviewFingerprint = data.fingerprint;
      clearPreview(row);
      return;
    }

    if (!dataElement.isConnected || !row.isConnected) return;
    clearPreview(row);
    media.append(buildPreview(preview));
    media.classList.add('kp-cart-preview-active');
    row.dataset.kpCartPreviewStatus = preview.status;
    row.dataset.kpCartPreviewFingerprint = data.fingerprint;
  };

  const renderAll = () => {
    document.querySelectorAll(DATA_SELECTOR).forEach((dataElement) => {
      renderLine(dataElement).catch((error) => {
        console.warn('[Kippush cart preview] Unable to render line.', error);
      });
    });
  };

  const schedule = () => {
    window.clearTimeout(renderTimer);
    renderTimer = window.setTimeout(renderAll, 60);
  };

  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('cart:update', schedule);
  window.addEventListener('pageshow', schedule);

  window.__kpCartPersonalizationPreview = {
    mappingSnapshot: READY_MAPPING_SNAPSHOT,
    render: renderAll,
    destroy() {
      observer.disconnect();
      window.clearTimeout(renderTimer);
      document.querySelectorAll(ROW_SELECTOR).forEach(clearPreview);
      delete window.__kpCartPersonalizationPreview;
    },
  };

  schedule();
})();



